import { render } from "./EditPerformanceTracker.vue?vue&type=template&id=4d883009"
import script from "./EditPerformanceTracker.vue?vue&type=script&lang=js"
export * from "./EditPerformanceTracker.vue?vue&type=script&lang=js"

import exportComponent from "D:\\fz\\1_Task\\hr.haite.sg\\orangehrm-5.2\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__